import { Component, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import { BModal } from "@/lib/typed-bootstrap";
import { Button, ButtonThemeEnum } from "../shared/Button.component";

@Component
export default class SessionExpiredModal extends Vue {
  _tsx!: tsx.DeclareProps<{}> & tsx.DeclareOnEvents<{}>;

  modalId = "session-modal";
  countDown = 60;
  timerId!: ReturnType<typeof setTimeout>;

  get title() {
    return this.$t("form_session_expired_title").toString();
  }

  get info(): string {
    return this.$t("form_session_expired_info", {
      countDown: this.countDown,
    }).toString();
  }

  get instruction(): string {
    return this.$t("form_session_expired_question").toString();
  }

  get logoutButtonTheme() {
    return ButtonThemeEnum.naked;
  }

  get continueButtonTheme() {
    return ButtonThemeEnum.primary;
  }

  countDownTimer() {
    if (this.countDown > 0) {
      this.timerId = setTimeout(() => {
        this.countDown -= 1;
        this.countDownTimer();
      }, 1000);
    } else {
      this.onLogout();
    }
  }

  showModal() {
    this.countDown = 60;
    this.countDownTimer();
  }

  resetModal() {
    clearTimeout(this.timerId);
  }

  onLogout() {
    this.$bvModal.hide(this.modalId);
    this.$authManager.logout();
  }

  onContinue() {
    this.$bvModal.hide(this.modalId);
  }

  render() {
    return (
      <BModal
        id={this.modalId}
        title={this.title}
        onShow={this.showModal}
        onHide={this.resetModal}
        onOk={this.onContinue}
        scopedSlots={{
          "modal-footer": () => (
            <div>
              <Button theme={this.logoutButtonTheme} onClick={this.onLogout}>
                {this.$t("form_cta_force_logout")}
              </Button>
              <Button
                theme={this.continueButtonTheme}
                onClick={this.onContinue}
              >
                {this.$t("form_cta_force_continue")}
              </Button>
            </div>
          ),
        }}
      >
        <p>{this.info}</p>
        <p>{this.instruction}</p>
      </BModal>
    );
  }
}
